export const findAvailableModule = (content, type1, type2) => {
  return content?.find(item => item._type === type1 || item._type === type2)
}
